var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'nobar-h100 body-' + _vm.account},[_c('b-container',[_c('b-row',[_c('b-col',[_c('h3',{staticClass:"text-center bg-white m-5 p-5"},[_vm._v(" "+_vm._s(_vm.$t("error.not_found"))+" ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }